import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Button, Icon, Popconfirm } from 'antd'
import { couponUnits } from '@texts/coupons'
import ToggleList from './ToggleList'

@inject((store: any) => {
    const { popupStore, servicesStore, subscriptionsStore, couponTypesStore, couponsStore } = store
    return { popupStore, servicesStore, subscriptionsStore, couponTypesStore, couponsStore }
})
@observer
export default class CouponType extends Component<any, any> {
    state = {
        showServices: false,
        showSubscriptions: false
    }
    toggleServices = () => this.setState(prevState => ({ showServices: !prevState.showServices }))
    toggleSubscriptions = () => this.setState(prevState => ({ showSubscriptions: !prevState.showSubscriptions }))
    handleActive = async () => {
        const {
            couponTypesStore: { getList, changeEditValue, setEditCouponType, submitCouponType },
            couponType
        } = this.props
        await setEditCouponType(couponType)
        await changeEditValue('active', couponType.active ? '0' : '1')
        await submitCouponType()
        await getList()
    }
    toggleCouponsList = async () => {
        const {
            couponType: { id },
            popupStore: { togglePopup },
            couponsStore: { getList, addFilter }
        } = this.props
        await addFilter('coupon_type_id', id)
        await addFilter('page', 1)
        await getList()
        togglePopup('couponsList')
    }
    filterSelected = (selected, all) => {
        let filtered
        if (selected) {
            const selectedArr = selected
                .replaceAll(' ', '')
                .replace('[', '')
                .replace(']', '')
                .split(',')
            filtered = all.filter(item => selectedArr.includes(item.id.toString()))
        }
        return filtered
    }
    render() {
        const {
            couponTypesStore: { setEditCouponType },
            couponType: {
                name,
                discount,
                services,
                subscriptions,
                min_price,
                max_discount,
                active,
                units,
                __meta__: { total_coupons, active_coupons }
            },
            popupStore: { togglePopup },
            servicesStore: { list: allServices },
            subscriptionsStore: { subscriptions: allSubs }
        } = this.props
        const servicesContent = (
            <ToggleList
                list={this.filterSelected(services, allServices)}
                title="שירותים משתתפים"
                notFoundTitle="לא נבחרו שירותים"
            />
        )
        const subscriptionsContent = (
            <ToggleList
                list={this.filterSelected(subscriptions, allSubs)}
                title="מסלולים משתתפים"
                notFoundTitle="לא נבחרו מסלולים"
            />
        )
        return (
            <div style={{ justifyContent: 'space-between', display: 'flex', width: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ paddingLeft: '1rem', width: '20rem', display: 'flex', flexDirection: 'row' }}>
                        <Button
                            onClick={() => {
                                setEditCouponType(this.props.couponType)
                                togglePopup('couponType')
                            }}
                        >
                            <Icon type="edit" />
                        </Button>
                        <div>
                            <div>{name}</div>
                            <div>
                                <strong>מצב</strong> {active ? 'פעיל' : 'לא פעיל'}
                                <Popconfirm
                                    title={active ? 'האם לכבות סוג קופון זה' : 'האם להפעיל סוג קופון זה'}
                                    okText="אישור"
                                    cancelText="ביטול"
                                    onConfirm={() => this.handleActive()}
                                >
                                    (<a style={{ textDecoration: 'underline' }}>{active ? 'כבה' : 'הפעל'}</a>)
                                </Popconfirm>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <strong>הנחה:</strong> {discount}
                            <small>{couponUnits[units]}</small>
                        </div>
                        {!!min_price && (
                            <div>
                                <strong>מינימום לאחר הנחה: </strong> {min_price}
                            </div>
                        )}
                        {!!max_discount && (
                            <div>
                                <strong>הנחה מקסימלית: </strong> {max_discount}
                            </div>
                        )}
                    </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>{servicesContent}</div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                    {subscriptionsContent}
                </div>
                <div
                    style={{
                        flexDirection: 'column',
                        justifyContent: 'center',
                        width: '10rem',
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    <div>
                        <Button onClick={() => this.toggleCouponsList()}>
                            <Icon type="unordered-list" /> רשימת קופונים
                        </Button>
                    </div>
                    <div>
                        {total_coupons > 0 ? (
                            <>
                                <strong>קופונים פעילים</strong> {active_coupons} מתוך {total_coupons}{' '}
                            </>
                        ) : (
                            'אין קופונים תחת סוג זה'
                        )}
                    </div>
                </div>
            </div>
        )
    }
}
